import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

// Get comprehensive duplication information for a specific applicant
// This endpoint returns both ex-employee and duplicate information
export const getApplicantDuplicationInfo = (applicantId) =>
    axios.get(`${apiUrl}ats/duplications/applicants/${applicantId}`);
